import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Button } from "../../../node_modules/@material-ui/core";
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import classNames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

import TerminalDetails from './TerminalDetails';
import StationDetails from "./StationDetails";

const styles = theme => ({
  wrapper: {
    position: 'relative',
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'center'
  },
  buttonSuccess: {
    width: "100%",
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonFailure: {
    width: "100%",
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});


class Step5 extends React.Component {

  render() {
    const { mainClasses, classes, oldTerminalData, newTerminalData, handleSubmitTerminalSwitch, submitState, handleBack} = this.props;
    const buttonClassname = classNames({
      [mainClasses.stepButton]: (!submitState || !submitState.isFailure || !submitState.isSuccess ),
      [classes.buttonSuccess]: (submitState && submitState.isSuccess),
      [classes.buttonFailure]: (submitState && submitState.hasFailed),
    });


    return (
      <React.Fragment>
          <Typography variant="title" component="h3" className={mainClasses.stepTitle}>Yhteenveto</Typography>
          <StationDetails stationPump={oldTerminalData.stationPump} />
          <TerminalDetails title={"Vanhan laitteen tiedot"} terminalData={oldTerminalData} />
          <TerminalDetails title={"Uuden laitteen tiedot"} terminalData={newTerminalData}/>
          <div className={classes.wrapper}>
          <Button
            variant="contained"
            color="primary"
            className={buttonClassname}
            disabled={(submitState && submitState.isloading)}
            onClick={handleSubmitTerminalSwitch}>
            Hyväksy
          </Button>
          {(submitState && submitState.isLoading) && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
          <div className={mainClasses.buttonWrapper}>
              <Button className={mainClasses.stepButton} variant="outlined" onClick={handleBack}>Back</Button>
          </div>
      </React.Fragment>
    );
  }
}


export default withStyles(styles)(Step5);



// WEBPACK FOOTER //
// ./src/components/Steps/Step5.js